import QuillEditor from "../util/QuillEditor";
import styles from "./PageEdit.module.css"

// component
import TextInput from "./TextInput";


/**
 * Used to set the address of th church
 *
 * @param {string} sectionKey - The section key (e.g., "Sec1", "PageHeader").
 * @param {string} header - The section header text.
 * @param {string} address - Address of the church.
 * @param {string} text - The section text.
 * @param {Function} updateField - Function to update the parent state.
 *
 */

export default function AddressEdit({sectionKey, header, address, text, id, updateField}) {

    return(
        <div className={styles.pageInfoEdit}>
             <h2>{header}</h2>

            {/* Header Input */}
            <TextInput
                label={"Header:"}
                value={header}
                onChange={(e) => updateField(sectionKey, "header", e.target.value)}
            />

            {/* Content id */}
            <TextInput
                label={"Id:"}
                value={id}
                onChange={(e) => updateField(sectionKey, "id", e.target.value)}
            />

            {/* content section Name */}
            <TextInput
                label={"adresse:"}
                value={address}
                onChange={(e) => updateField(sectionKey, "address", e.target.value)}
            />

            {/* Content Editor */}
            <QuillEditor
                value={text || ""}
                onChange={(value) => updateField(sectionKey, "text", value)}
                placeholder="Write your content here..."
            />
        </div>
    );

}